// extracted by mini-css-extract-plugin
export default {"container":"_1305dgIt","staffPicksBadge":"_31ccl3lb"};